module.exports = __webpack_public_path__ + "static/media/regulatory_large.35219ce1.jpg";